import { render, staticRenderFns } from "./MetadadosCampoDinamicoData.vue?vue&type=template&id=6af0615c&"
import script from "./MetadadosCampoDinamicoData.vue?vue&type=script&lang=js&"
export * from "./MetadadosCampoDinamicoData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/shared-components/metadados/campos-dinamicos/MetadadosCampoDinamicoData.vue
// module id = 1339
// module chunks = 28